import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useContext, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var UserCredentialsContext = /*#__PURE__*/createContext(undefined);
export var UserCredentialsContextProvider = function UserCredentialsContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      customerID = _useState2[0],
      setCustomerID = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      password = _useState4[0],
      setPassword = _useState4[1];

  var value = useMemo(function () {
    return {
      customerID: customerID,
      password: password,
      setCustomerID: setCustomerID,
      setPassword: setPassword
    };
  }, [customerID, password]);
  return /*#__PURE__*/_jsx(UserCredentialsContext.Provider, {
    value: value,
    children: children
  });
};
export var useUserCredentialsContext = function useUserCredentialsContext() {
  var context = useContext(UserCredentialsContext);

  if (context) {
    return context;
  }

  throw new Error('UserCredentialsContext value must be set.');
};